/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useContext } from "react";
import { ContentZoneContext } from "cms/components/context";
import { LargeCalendarFilter } from "cms/components/components/feed-calendar/display/large";
import { getModelName } from "data/resources/model-items-config";

const FeedCalendarComponentDisplay = () => {

    const { component } = useContext(ContentZoneContext);
    const {
        selected_type,
        selected_category,
        enable_bar: enable_bar,
    } = component || {};
    const hasType = !!selected_type;
    const selected_type_name = hasType ? getModelName(selected_type) : "None";

    return (
        <>
            <h2>Selected Model Type: {selected_type_name}</h2>
            <h3>Selected Category: {selected_category}</h3>
            {hasType &&
                <LargeCalendarFilter
                    type={selected_type}
                    selected_type_name={selected_type_name}
                    selectedCategory={selected_category}
                    enableBar={enable_bar}
                />
            }
        </>
    );
};

FeedCalendarComponentDisplay.displayName = "FeedCalendarComponentDisplay";
export { FeedCalendarComponentDisplay };
